import { useEffect, useState } from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import Countdown from "react-countdown";

const CountdownTimer = ({
  endTime = Date.now() + 48 * 60 * 60 * 1000, // Default to 48 hours from now
  label = "SALE ENDS SOON:",
  sx = {},
  ...props
}) => {
  const [saleCountdown] = useState({
    expiresAt: endTime,
    expired: false,
  });
  const [countdownReady, setCountdownReady] = useState(false);

  // Small delay to ensure countdown renders properly
  useEffect(() => {
    const timer = setTimeout(() => setCountdownReady(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const CountdownRenderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>Expired</span>;
    }
    return (
      <span>
        {hours}h {minutes}m {seconds}s
      </span>
    );
  };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "success.main",
        color: "success.main",
        borderRadius: "16px",
        padding: "4px 12px",
        marginTop: "8px",
        justifyContent: "center",
        whiteSpace: "nowrap",
        ...sx,
      }}
      {...props}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, display: "flex", alignItems: "center" }}
      >
        <Box component="span" sx={{ mr: 1 }}>
          {label}
        </Box>
        <Box
          component="span"
          sx={{
            display: "inline-block",
            minWidth: "80px",
            textAlign: "center",
            fontVariantNumeric: "tabular-nums",
            height: "20px",
            lineHeight: "20px",
          }}
        >
          {countdownReady ? (
            <Countdown
              date={saleCountdown.expiresAt}
              renderer={CountdownRenderer}
            />
          ) : (
            <Skeleton
              animation="wave"
              variant="text"
              sx={{
                py: 0,
                width: "80px",
                height: "20px",
                lineHeight: "20px",
                display: "inline-block",
                backgroundColor: "rgba(0, 0, 0, 0.11)",
              }}
            />
          )}
        </Box>
      </Typography>
    </Box>
  );
};

export default CountdownTimer;
